import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../i18n/translate.pipe';

@Component({
  selector: 'cmi-back-button',
  imports: [TranslatePipe],
  templateUrl: './back-button.html'
})
export class BackButton {
  private readonly _location = inject(Location);

  public goBack(): void {
    this._location.back();
  }
}
